import { render, staticRenderFns } from "./carinsuranceinformation.vue?vue&type=template&id=467bcf93&scoped=true"
import script from "./carinsuranceinformation.vue?vue&type=script&lang=js"
export * from "./carinsuranceinformation.vue?vue&type=script&lang=js"
import style0 from "./carinsuranceinformation.vue?vue&type=style&index=0&id=467bcf93&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467bcf93",
  null
  
)

export default component.exports